__turbopack_context__.v({
  "address": "style-module-scss-module__K85qbG__address",
  "badge": "style-module-scss-module__K85qbG__badge",
  "content": "style-module-scss-module__K85qbG__content",
  "image": "style-module-scss-module__K85qbG__image",
  "media": "style-module-scss-module__K85qbG__media",
  "meta": "style-module-scss-module__K85qbG__meta",
  "title": "style-module-scss-module__K85qbG__title",
});
